/*       */

import styled from 'styled-components';
import { Avatar } from '@mic3/platform-ui';

const TypeaheadAdornmentInitials = styled(Avatar)`
    width: 21px !important;
    height: 21px !important;
    font-size: 0.9rem !important;
`;

const TypeaheadChipInitials = styled(Avatar)`
    margin-left: 0 !important;
`;

export { TypeaheadChipInitials, TypeaheadAdornmentInitials };
